
  import {Component, Vue, Watch} from "vue-property-decorator";
  import {ChangePasswordDto} from "@/api/appService";
  import api from "@/api";

  @Component({
    name:'ChangePassword'
  })
  export default class ChangePassword extends Vue{

    private defaultData :ChangePasswordDto = {
      currentPassword:'',
      newPassword:''
    }

    private dto:ChangePasswordDto = {}

    public show = false;

    created(){
      this.dto = {...this.defaultData};
    }


    @Watch('show')
    onShowChange(value:boolean){
      if(!value){
        this.dto = {...this.defaultData};
        this.$nextTick(()=>{
          (this.$refs.dataForm as any).clearValidate();
        });

      }
    }

    handleUpdate(){
      (this.$refs.dataForm as any).validate((valid: boolean) => {
        if (valid) {
          api.user.changePassword({body:this.dto}).then(res=>{
            this.show = false;
            this.$message.success('密码修改成功');
          })

        }
      });
    }

    rules = {
      currentPassword:[
        {required:true,message:'请输入旧密码',trigger:['change','blur']}

      ],
      newPassword:[
        {required:true,message:'请输入新密码',trigger:['change','blur']},
        {
          type:'string',
          validator:(rule:any,value:string,callback:Function)=>{
            if(value && value.length>=6){
              callback();
            } else {
              callback(new Error('密码长度不能小于6个字符'));
            }
          }
        }
      ]
    }


  }
